{
  "name": "alpha-kit",
  "version": "0.0.4",
  "description": "Advanced CLI for Alpha UI components & premium blocks - Next-generation component library for modern web applications",
  "bin": {
    "alpha": "dist/index.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/alpha-ion/ui.git"
  },
  "homepage": "https://alphabyte-ui.vercel.app",
  "bugs": {
    "url": "https://github.com/alpha-ion/cli/issues"
  },
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    }
  },
  "files": [
    "dist/**",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "test": "echo \"No test specified\" && exit 0",
    "dev": "tsup --watch --onSuccess \"node scripts/copy-registry.js\"",
    "build": "tsup && node scripts/copy-registry.js",
    "prepack": "pnpm build",
    "typecheck": "tsc --noEmit",
    "start": "node dist/index.js",
    "format:write": "prettier --write \"**/*.{ts,tsx,mdx}\" --cache",
    "format:check": "prettier --check \"**/*.{ts,tsx,mdx}\" --cache",
    "prepublishOnly": "pnpm build",
    "publish:npm": "npm publish --access public",
    "publish:gh": "npm publish --registry=https://npm.pkg.github.com",
    "publish:all": "pnpm build && npm run publish:npm && npm run publish:gh"
  },
  "keywords": [
    "alphion",
    "alphion-ui",
    "ui-library",
    "react-components",
    "nextjs",
    "tailwind",
    "shadcn",
    "cli",
    "components",
    "blocks",
    "premium-ui",
    "design-system",
    "typescript",
    "web-components",
    "ui-kit"
  ],
  "author": "Ali Abdelhadi <ali@alphion-ui.dev> (https://alphion-ui.dev)",
  "license": "MIT",
  "engines": {
    "node": ">=18"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "dependencies": {
    "@antfu/ni": "^25.0.0",
    "@babel/core": "^7.28.0",
    "@babel/parser": "^7.28.0",
    "@babel/plugin-transform-typescript": "^7.28.0",
    "@clack/prompts": "^0.11.0",
    "commander": "^14.0.0",
    "cosmiconfig": "^9.0.0",
    "dedent": "^1.6.0",
    "deepmerge": "^4.3.1",
    "execa": "^9.6.0",
    "fast-glob": "^3.3.3",
    "fs-extra": "^11.3.1",
    "fuzzysort": "^3.1.0",
    "https-proxy-agent": "^7.0.6",
    "kleur": "^4.1.5",
    "node-fetch": "^3.3.2",
    "ora": "^8.2.0",
    "postcss": "^8.5.6",
    "prompts": "^2.4.2",
    "recast": "^0.23.11",
    "stringify-object": "^5.0.0",
    "ts-morph": "^26.0.0",
    "tsconfig-paths": "^4.2.0",
    "zod": "^3.24.1"
  },
  "devDependencies": {
    "@types/babel__core": "^7.20.5",
    "@types/fs-extra": "^11.0.4",
    "@types/prompts": "^2.4.9",
    "@types/stringify-object": "^4.0.5",
    "rimraf": "^6.0.1",
    "tsup": "^8.5.0",
    "typescript": "^5.9.2",
    "vitest": "^3.2.4"
  }
}